import { t } from 'i18next';
import React, { useEffect, useRef, useState } from 'react';
import MyApi,{ baseURL }  from '../components/MyApi';
import AsyncSelect from 'react-select/async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Modal, Button } from 'react-bootstrap'
import IndicateursStats from '../components/IndicateursStats';
import ReactToPrint from "react-to-print";
function Indicateurs() {

  let componentRef = useRef();

  const { t,i18n } = useTranslation()
  const currentLanguageCode = i18n.language
 
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [listIndicateurs, setListIndicateurs] = useState(null);

  const [idIndicateur, setIdIndicateur] = useState(null);
  const [typeIndicateur, setTypeIndicateur] = useState(null);
  const [chartData, setChartData] = useState([]);


  const [isShow, setShow] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const [isShowStats, setShowStats] = useState(false)
  const handleCloseStats = () => setShowStats(false);
  const handleShowStats = () => setShowStats(true);

  const [typeChart, setTypeChart] = useState('line');

  const fetchYears = () => {
    return MyApi.get('/getAllYearRecette').then(result => {
      const res = result.data;
      setSelectedValue(res.at(-1));
      return res;
    });
  }


  // handle selection
  const handleChange = value => {
    setSelectedValue(value);
    setSelectedYear(value.year);
    const apiUrl = baseURL + '/getIndicateursByYear/' + value.year;

    loadData(apiUrl);

    
  }


  let loadData = (apiUrl) => {
    MyApi.get(apiUrl).then(result => {
      const res = result.data;
      setListIndicateurs(res);
    });
  }


  useEffect(() => {
    
    if (selectedValue != null) {
    const apiUrl = baseURL + '/getIndicateursByYear/' + selectedValue.year;
    loadData(apiUrl);
  }



  let chartTypeValue = document.getElementById('chartTypeValue');
    setTypeChart(chartTypeValue.value); 
      if(chartTypeValue){
       chartTypeValue.addEventListener("change", () => {
       setTypeChart(chartTypeValue.value); 
     });
     }


  } , [selectedValue]);




    return (
            
        <section className="services-section-four">
          

            <div className='auto-container'>
                <div className='row'>



                <Modal show={isShow} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title> 
                     
                      <i className='fa fa-file-text-o fa-2x text-primary pad5'></i>
                    {(() => {
                                switch (idIndicateur) {
                                  case 1:
                                    return <b>{t('indicateur1')}</b>;
                                  case 2:
                                    return <b>{t('indicateur2')}</b>;
                                    case 3:
                                      return <b>{t('indicateur3')}</b>;
                                      case 4:
                                        return <b>{t('indicateur4')}</b>;
                                        case 5:
                                          return <b>{t('indicateur5')}</b>;
                                          case 6:
                                            return <b>{t('indicateur6')}</b>;
                                            case 7:
                                              return <b>{t('indicateur7')}</b>;
                                              case 8:
                                                return <b>{t('indicateur8')}</b>;
                                                case 9:
                                                  return <b>{t('indicateur9')}</b>;
                                                  case 10:
                                                    return <b>{t('indicateur10')}</b>;
                                  default:
                                    return <b></b>;
                                }
                            })()}

                            
                   
                    </Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    <div className='row'>
                    <div className='col-md-12 text-center'>
                  {(() => {
                                switch (idIndicateur) {
                                  case 1:
                                    return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind1_1')} / {t('ind1_2')}</span></b>;                                 
                                  case 2:
                                    return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind2_1')} / {t('ind2_2')}</span></b>;    
                                    case 3:
                                      return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind3_1')} / {t('ind3_2')}</span></b>;
                                      case 4:
                                        return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind4_1')} / {t('ind4_2')}</span></b>;
                                        case 5:
                                          return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind5_1')} / {t('ind5_2')}</span></b>;
                                          case 6:
                                            return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind6_1')} / {t('ind6_2')}</span></b>;
                                            case 7:
                                              return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind7_1')} / {t('ind7_2')}</span></b>;
                                              case 8:
                                                return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind8_1')} / {t('ind8_2')}</span></b>;
                                                case 9:
                                                  return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind9_1')} / {t('ind9_2')}</span></b>;
                                                  case 10:
                                                    return<b> <i className='fa fa-calculator fa-2x text-primary'></i> <span className='text-primary'>{t('calcul')} = </span> <span className='indicFiche'>{t('ind10_1')} / {t('ind10_2')}</span></b>;                             
                                  default:
                                    return <b></b>;
                                }
                            })()}

                  </div>
                  </div>
                  </Modal.Body>


                  <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                    <i className='fa fa-close'> </i> {t('fermer')}
                    </Button>
                  </Modal.Footer>
                </Modal>






                <Modal show={isShowStats} onHide={handleCloseStats}>
                  <Modal.Header closeButton>
                    <Modal.Title> 
                     
                      <i className='fa fa-area-chart fa-2x text-warning pad5'></i>
                    {(() => {
                                switch (idIndicateur) {
                                  case 1:
                                    return <b>{t('indicateur1')}</b>;
                                  case 2:
                                    return <b>{t('indicateur2')}</b>;
                                    case 3:
                                    return <b>{t('indicateur3')}</b>;
                                    case 4:
                                    return <b>{t('indicateur4')}</b>;
                                    case 5:
                                    return <b>{t('indicateur5')}</b>;
                                    case 6:
                                    return <b>{t('indicateur6')}</b>;
                                    case 7:
                                    return <b>{t('indicateur7')}</b>;
                                    case 8:
                                    return <b>{t('indicateur8')}</b>;
                                    case 9:
                                    return <b>{t('indicateur9')}</b>;
                                    case 10:
                                    return <b>{t('indicateur10')}</b>;
                                  default:
                                    return <b></b>;
                                }
                            })()}

                            
                   
                    </Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                  <IndicateursStats   currentLanguageCode={currentLanguageCode} idIndicateur = {idIndicateur} data= {chartData} typeIndicateur= {typeIndicateur} typeChart={typeChart}/>
                  </Modal.Body>


                  <Modal.Footer>
                    <Button variant="danger" onClick={handleCloseStats}>
                    <i className='fa fa-close'> </i> {t('fermer')}
                    </Button>
                  </Modal.Footer>
                </Modal>





               
                <div className='col-md-12'>


                    
                  <div className='col-md-12 row'>
                    
                    
                  <div className="col-md-2 pad5">
                    <AsyncSelect
                      placeholder={t('VCHA')}
                      cacheOptions
                      defaultOptions
                      value={selectedValue}
                      getOptionLabel={e => e.year}
                      getOptionValue={e => e.year}
                      loadOptions={fetchYears}
                      onChange={handleChange}
                    
                    />
                  </div>
                  <ReactToPrint 
                    trigger={() => <Button className='btnPrint'><i className='fa fa-print'></i> {t('imprimer')}</Button>}
                    content={() => componentRef}
                   />
                  <div className="col-md-12 pad5">
                  
                  
                 
                 <div className='' ref={(el) => (componentRef = el)}>

<h3 className='indicTitle'>{t('indicateurs')} </h3>

                  <table className="table table-bordered indicTable"  >
                        <thead>
                          <tr>
                            <th scope="col">{t('indic')}</th>
                            <th scope="col">{t('annee')}</th>
                            <th scope="col">{t('valeur')}</th>
                            <th scope="col"><i className='fa fa-exchange'></i> {t('variation')}</th>
                            <th scope="col">{t('valeurNational')}</th>
                            <th scope="col"><i className='fa fa-exchange'></i> {t('variationNational')}</th>
                            <th className='no-print' scope="col">{t('fiche')}</th>
                            <th className='no-print' scope="col">{t('statistique')}</th>
                          </tr>
                        </thead>
                        <tbody>

                        {listIndicateurs && listIndicateurs.map((item, index) => 
                          <tr key={index.toString()}>
                            <td>
                            {(() => {
                                switch (item.id) {
                                  case 1:
                                    return <b>{t('indicateur1')}</b>;
                                  case 2:
                                    return <b>{t('indicateur2')}</b>;
                                    case 3:
                                    return <b>{t('indicateur3')}</b>;
                                    case 4:
                                    return <b>{t('indicateur4')}</b>;
                                    case 5:
                                    return <b>{t('indicateur5')}</b>;
                                    case 6:
                                    return <b>{t('indicateur6')}</b>;
                                    case 7:
                                    return <b>{t('indicateur7')}</b>;
                                    case 8:
                                    return <b>{t('indicateur8')}</b>;
                                    case 9:
                                    return <b>{t('indicateur9')}</b>;
                                    case 10:
                                    return <b>{t('indicateur10')}</b>;
                                  default:
                                    return <b></b>;
                                }
                            })()}
                         </td>
                            <td>{item.year} </td>
                            <td className='valueTd'>{item.typeData==='percent'?item.valeur:item.valeur+' '+t('dt') }</td>
                            <td>
                            <i className={item.variationIcon}></i>
                           <span className=''> {item.typeData==='percent'?item.variation:item.variation+' '+t('dt') }</span>
                            </td>
                            <td className='valueTd2'>{item.typeData==='percent'?item.valeurNational:item.valeurNational+' '+t('dt') }</td>
                            <td>
                            <i className={item.variationNationalIcon}></i>
                           <span className=''> {item.typeData==='percent'?item.variationNational:item.variationNational+' '+t('dt') }</span>
                            </td>
                            <td className='text-center no-print'><button className='btnFiche' onClick={() => { setIdIndicateur(item.id); handleShow();}    }><i className='fa fa-file-text-o fa-2x text-primary'></i></button></td>
                           
                            <td className='text-center no-print'><button className='btnFiche' onClick={() => {setTypeIndicateur(item.typeData);setChartData(item.data); setIdIndicateur(item.id); handleShowStats();}    }><i className='fa fa-area-chart fa-2x text-warning'></i></button></td>
                          </tr>
                        )}
                        </tbody>
                      </table>

                      </div>



                    </div>




                  </div>

              </div>



                   
                </div>


            </div>

        </section>
    )
 
}


export default Indicateurs  